<template>
  <btn-toggle v-model="model" :category="category" itemText="name" itemValue="value" :disabled="disabled" />
</template>

<script>
import BtnToggle from '@/components/atoms/base/button/BtnToggle'

export default {
  name: 'BtnChooseValid',

  components: { BtnToggle },

  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      category: [
        { name: this.$t('isValid.true'), value: true },
        { name: this.$t('isValid.false'), value: false },
      ],
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
